// AUTO-GENERATED BY generateRouteManifest.ts — DO NOT EDIT
// This file is safe to import in edge runtime (no Node APIs).

export type RouteNode = {
  staticChildren?: Record<string, RouteNode>
  dynamicChild?: { paramName: string; child: RouteNode } | null
  catchAll?: { paramName: string; child: RouteNode } | null
  optionalCatchAll?: { paramName: string; child: RouteNode } | null
  hasPage?: boolean
  hasRoute?: boolean
  lowerCase?: Record<string, string>
}

export const routeTrie = {
  "staticChildren": {
    ".well-known": {
      "staticChildren": {
        "ai-agents.json": {
          "hasRoute": true
        },
        "oauth-authorization-server": {
          "hasRoute": true
        },
        "oauth-protected-resource": {
          "hasRoute": true
        }
      },
      "lowerCase": {
        "ai-agents.json": "ai-agents.json",
        "oauth-authorization-server": "oauth-authorization-server",
        "oauth-protected-resource": "oauth-protected-resource"
      }
    },
    "SKILL.md": {
      "hasRoute": true
    },
    "abTestGroups": {
      "hasPage": true
    },
    "about": {
      "hasPage": true
    },
    "account": {
      "hasPage": true
    },
    "admin": {
      "staticChildren": {
        "commentEmbeddings": {
          "hasPage": true
        },
        "curation": {
          "hasPage": true
        },
        "debugDatabaseDifferences": {
          "hasPage": true
        },
        "debugHeaders": {
          "hasRoute": true
        },
        "designReview": {
          "staticChildren": {
            "inspector": {
              "hasPage": true
            }
          },
          "lowerCase": {
            "inspector": "inspector"
          }
        },
        "emailSender": {
          "hasPage": true
        },
        "llmConversations": {
          "hasPage": true
        },
        "migrations": {
          "hasPage": true
        },
        "moderationTemplates": {
          "hasPage": true
        },
        "pangram": {
          "hasPage": true
        },
        "random-user": {
          "hasPage": true
        },
        "supermod": {
          "hasPage": true
        },
        "synonyms": {
          "hasPage": true
        },
        "tagMerge": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "commentembeddings": "commentEmbeddings",
        "curation": "curation",
        "debugdatabasedifferences": "debugDatabaseDifferences",
        "debugheaders": "debugHeaders",
        "designreview": "designReview",
        "emailsender": "emailSender",
        "llmconversations": "llmConversations",
        "migrations": "migrations",
        "moderationtemplates": "moderationTemplates",
        "pangram": "pangram",
        "random-user": "random-user",
        "supermod": "supermod",
        "synonyms": "synonyms",
        "tagmerge": "tagMerge"
      },
      "hasPage": true
    },
    "allComments": {
      "hasPage": true
    },
    "allCommentsWithReacts": {
      "hasPage": true
    },
    "allPosts": {
      "hasPage": true
    },
    "allgroups": {
      "hasPage": true
    },
    "analyticsEvent": {
      "hasRoute": true
    },
    "api": {
      "staticChildren": {
        "EDITOR_API_AND_GUIDELINES.md": {
          "hasRoute": true
        },
        "SKILL.md": {
          "hasRoute": true
        },
        "about": {
          "hasRoute": true
        },
        "codex": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasRoute": true
            }
          },
          "hasRoute": true
        },
        "community": {
          "hasRoute": true
        },
        "contact": {
          "hasRoute": true
        },
        "curated": {
          "hasRoute": true
        },
        "editPost": {
          "hasRoute": true
        },
        "events": {
          "dynamicChild": {
            "paramName": "id",
            "child": {
              "dynamicChild": {
                "paramName": "slug",
                "child": {
                  "hasRoute": true
                }
              },
              "hasRoute": true
            }
          }
        },
        "faq": {
          "hasRoute": true
        },
        "home": {
          "hasRoute": true
        },
        "hpmor": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasRoute": true
            }
          },
          "hasRoute": true
        },
        "latest": {
          "hasRoute": true
        },
        "markdown-unavailable": {
          "hasRoute": true
        },
        "post": {
          "dynamicChild": {
            "paramName": "idOrSlug",
            "child": {
              "staticChildren": {
                "comments": {
                  "dynamicChild": {
                    "paramName": "commentId",
                    "child": {
                      "hasRoute": true
                    }
                  },
                  "hasRoute": true
                }
              },
              "lowerCase": {
                "comments": "comments"
              },
              "hasRoute": true
            }
          }
        },
        "rationality": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasRoute": true
            }
          },
          "hasRoute": true
        },
        "recent": {
          "hasRoute": true
        },
        "sequence": {
          "dynamicChild": {
            "paramName": "id",
            "child": {
              "staticChildren": {
                "post": {
                  "dynamicChild": {
                    "paramName": "postId",
                    "child": {
                      "hasRoute": true
                    }
                  }
                }
              },
              "lowerCase": {
                "post": "post"
              },
              "hasRoute": true
            }
          }
        },
        "tag": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasRoute": true
            }
          }
        },
        "user": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasRoute": true
            }
          }
        },
        "agent": {
          "staticChildren": {
            "commentOnDraft": {
              "hasRoute": true
            },
            "confirmClaudeAccess": {
              "dynamicChild": {
                "paramName": "token",
                "child": {
                  "hasRoute": true
                }
              }
            },
            "deleteBlock": {
              "hasRoute": true
            },
            "feedback": {
              "hasRoute": true
            },
            "insertBlock": {
              "hasRoute": true
            },
            "insertLLMBlock": {
              "hasRoute": true
            },
            "insertWidget": {
              "hasRoute": true
            },
            "ping": {
              "hasRoute": true
            },
            "replaceText": {
              "hasRoute": true
            },
            "replaceWidget": {
              "hasRoute": true
            },
            "replyToComment": {
              "hasRoute": true
            },
            "resolveCommentThread": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "commentondraft": "commentOnDraft",
            "confirmclaudeaccess": "confirmClaudeAccess",
            "deleteblock": "deleteBlock",
            "feedback": "feedback",
            "insertblock": "insertBlock",
            "insertllmblock": "insertLLMBlock",
            "insertwidget": "insertWidget",
            "ping": "ping",
            "replacetext": "replaceText",
            "replacewidget": "replaceWidget",
            "replytocomment": "replyToComment",
            "resolvecommentthread": "resolveCommentThread"
          }
        },
        "autocomplete": {
          "hasRoute": true
        },
        "autocomplete405b": {
          "hasRoute": true
        },
        "cron": {
          "staticChildren": {
            "curation-status-to-slack": {
              "hasRoute": true
            },
            "every-five-minutes": {
              "hasRoute": true
            },
            "every-hour": {
              "hasRoute": true
            },
            "every-midnight": {
              "hasRoute": true
            },
            "every-minute": {
              "hasRoute": true
            },
            "every-ten-minutes": {
              "hasRoute": true
            },
            "run-twitter-bot": {
              "hasRoute": true
            },
            "supermod-status-to-slack": {
              "hasRoute": true
            },
            "update-analytics-collections": {
              "hasRoute": true
            },
            "update-missing-post-embeddings": {
              "hasRoute": true
            },
            "update-promoted-spotlight-item": {
              "hasRoute": true
            },
            "update-review-vote-totals": {
              "hasRoute": true
            },
            "update-user-activities": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "curation-status-to-slack": "curation-status-to-slack",
            "every-five-minutes": "every-five-minutes",
            "every-hour": "every-hour",
            "every-midnight": "every-midnight",
            "every-minute": "every-minute",
            "every-ten-minutes": "every-ten-minutes",
            "run-twitter-bot": "run-twitter-bot",
            "supermod-status-to-slack": "supermod-status-to-slack",
            "update-analytics-collections": "update-analytics-collections",
            "update-missing-post-embeddings": "update-missing-post-embeddings",
            "update-promoted-spotlight-item": "update-promoted-spotlight-item",
            "update-review-vote-totals": "update-review-vote-totals",
            "update-user-activities": "update-user-activities"
          }
        },
        "dropAndCreatePg": {
          "hasRoute": true
        },
        "getLlmFeedback": {
          "hasRoute": true
        },
        "health": {
          "hasRoute": true
        },
        "homeDesignChat": {
          "hasRoute": true
        },
        "homeDesigns": {
          "staticChildren": {
            "SKILL.md": {
              "hasRoute": true
            },
            "publish": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "skill.md": "SKILL.md",
            "publish": "publish"
          },
          "hasRoute": true
        },
        "mcp": {
          "hasRoute": true
        },
        "notificationCount": {
          "hasRoute": true
        },
        "notificationEvents": {
          "hasRoute": true
        },
        "quit": {
          "hasRoute": true
        },
        "registerClientId": {
          "hasRoute": true
        },
        "research": {
          "staticChildren": {
            "agent": {
              "staticChildren": {
                "conversations": {
                  "dynamicChild": {
                    "paramName": "conversationId",
                    "child": {
                      "staticChildren": {
                        "events": {
                          "hasRoute": true
                        },
                        "presentation": {
                          "hasRoute": true
                        },
                        "transcript": {
                          "hasRoute": true
                        }
                      },
                      "lowerCase": {
                        "events": "events",
                        "presentation": "presentation",
                        "transcript": "transcript"
                      }
                    }
                  }
                },
                "documents": {
                  "staticChildren": {
                    "commentOnDocument": {
                      "hasRoute": true
                    },
                    "deleteBlock": {
                      "hasRoute": true
                    },
                    "insertBlock": {
                      "hasRoute": true
                    },
                    "insertLLMBlock": {
                      "hasRoute": true
                    },
                    "insertWidget": {
                      "hasRoute": true
                    },
                    "replaceText": {
                      "hasRoute": true
                    },
                    "replaceWidget": {
                      "hasRoute": true
                    },
                    "replyToComment": {
                      "hasRoute": true
                    }
                  },
                  "lowerCase": {
                    "commentondocument": "commentOnDocument",
                    "deleteblock": "deleteBlock",
                    "insertblock": "insertBlock",
                    "insertllmblock": "insertLLMBlock",
                    "insertwidget": "insertWidget",
                    "replacetext": "replaceText",
                    "replacewidget": "replaceWidget",
                    "replytocomment": "replyToComment"
                  },
                  "dynamicChild": {
                    "paramName": "documentId",
                    "child": {
                      "hasRoute": true
                    }
                  }
                },
                "projects": {
                  "dynamicChild": {
                    "paramName": "projectId",
                    "child": {
                      "staticChildren": {
                        "conversations": {
                          "hasRoute": true
                        },
                        "documents": {
                          "hasRoute": true
                        }
                      },
                      "lowerCase": {
                        "conversations": "conversations",
                        "documents": "documents"
                      }
                    }
                  }
                },
                "sandboxes": {
                  "dynamicChild": {
                    "paramName": "sandboxId",
                    "child": {
                      "staticChildren": {
                        "heartbeat": {
                          "hasRoute": true
                        }
                      },
                      "lowerCase": {
                        "heartbeat": "heartbeat"
                      }
                    }
                  }
                }
              },
              "lowerCase": {
                "conversations": "conversations",
                "documents": "documents",
                "projects": "projects",
                "sandboxes": "sandboxes"
              }
            },
            "conversations": {
              "dynamicChild": {
                "paramName": "conversationId",
                "child": {
                  "staticChildren": {
                    "events": {
                      "staticChildren": {
                        "stream": {
                          "hasRoute": true
                        }
                      },
                      "lowerCase": {
                        "stream": "stream"
                      }
                    }
                  },
                  "lowerCase": {
                    "events": "events"
                  }
                }
              }
            }
          },
          "lowerCase": {
            "agent": "agent",
            "conversations": "conversations"
          }
        },
        "search": {
          "staticChildren": {
            "userFacets": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "userfacets": "userFacets"
          },
          "hasRoute": true
        },
        "sendLlmChat": {
          "hasRoute": true
        },
        "streamGraphql": {
          "hasRoute": true
        },
        "v2": {
          "staticChildren": {
            "crosspost": {
              "staticChildren": {
                "connectCrossposter": {
                  "hasRoute": true
                },
                "crosspost": {
                  "hasRoute": true
                },
                "crosspostDetails": {
                  "hasRoute": true
                },
                "crossposterDetails": {
                  "hasRoute": true
                },
                "generateToken": {
                  "hasRoute": true
                },
                "unlinkCrossposter": {
                  "hasRoute": true
                },
                "updateCrosspost": {
                  "hasRoute": true
                }
              },
              "lowerCase": {
                "connectcrossposter": "connectCrossposter",
                "crosspost": "crosspost",
                "crosspostdetails": "crosspostDetails",
                "crossposterdetails": "crossposterDetails",
                "generatetoken": "generateToken",
                "unlinkcrossposter": "unlinkCrossposter",
                "updatecrosspost": "updateCrosspost"
              }
            }
          },
          "lowerCase": {
            "crosspost": "crosspost"
          }
        }
      },
      "lowerCase": {
        "editor_api_and_guidelines.md": "EDITOR_API_AND_GUIDELINES.md",
        "skill.md": "SKILL.md",
        "about": "about",
        "codex": "codex",
        "community": "community",
        "contact": "contact",
        "curated": "curated",
        "editpost": "editPost",
        "events": "events",
        "faq": "faq",
        "home": "home",
        "hpmor": "hpmor",
        "latest": "latest",
        "markdown-unavailable": "markdown-unavailable",
        "post": "post",
        "rationality": "rationality",
        "recent": "recent",
        "sequence": "sequence",
        "tag": "tag",
        "user": "user",
        "agent": "agent",
        "autocomplete": "autocomplete",
        "autocomplete405b": "autocomplete405b",
        "cron": "cron",
        "dropandcreatepg": "dropAndCreatePg",
        "getllmfeedback": "getLlmFeedback",
        "health": "health",
        "homedesignchat": "homeDesignChat",
        "homedesigns": "homeDesigns",
        "mcp": "mcp",
        "notificationcount": "notificationCount",
        "notificationevents": "notificationEvents",
        "quit": "quit",
        "registerclientid": "registerClientId",
        "research": "research",
        "search": "search",
        "sendllmchat": "sendLlmChat",
        "streamgraphql": "streamGraphql",
        "v2": "v2"
      },
      "catchAll": {
        "paramName": "path",
        "child": {
          "hasRoute": true
        }
      },
      "hasRoute": true
    },
    "arbital": {
      "hasPage": true
    },
    "auth": {
      "staticChildren": {
        "github": {
          "staticChildren": {
            "callback": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "callback": "callback"
          },
          "hasRoute": true
        },
        "google": {
          "staticChildren": {
            "callback": {
              "hasRoute": true
            }
          },
          "lowerCase": {
            "callback": "callback"
          },
          "hasRoute": true
        },
        "linkgdrive": {
          "hasRoute": true
        }
      },
      "lowerCase": {
        "github": "github",
        "google": "google",
        "linkgdrive": "linkgdrive"
      }
    },
    "autocompleteSettings": {
      "hasPage": true
    },
    "banNotice": {
      "hasPage": true
    },
    "bestoflesswrong": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "dynamicChild": {
            "paramName": "topic",
            "child": {
              "hasPage": true
            }
          }
        }
      },
      "hasPage": true
    },
    "bestoflesswrongadmin": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "bookmarks": {
      "hasPage": true
    },
    "books": {
      "staticChildren": {
        "2018": {
          "hasPage": true
        },
        "2019": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "2018": "2018",
        "2019": "2019"
      },
      "hasPage": true
    },
    "cache": {
      "staticChildren": {
        "posts": {
          "dynamicChild": {
            "paramName": "postId",
            "child": {
              "optionalCatchAll": {
                "paramName": "slug",
                "child": {
                  "hasRoute": true
                }
              }
            }
          }
        }
      },
      "lowerCase": {
        "posts": "posts"
      }
    },
    "ckeditor-token": {
      "hasRoute": true
    },
    "ckeditor-webhook": {
      "hasRoute": true
    },
    "codex": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      },
      "hasPage": true
    },
    "collections": {
      "dynamicChild": {
        "paramName": "_id",
        "child": {
          "hasPage": true
        }
      }
    },
    "community": {
      "hasPage": true
    },
    "compare": {
      "staticChildren": {
        "post": {
          "dynamicChild": {
            "paramName": "_id",
            "child": {
              "dynamicChild": {
                "paramName": "slug",
                "child": {
                  "hasPage": true
                }
              }
            }
          }
        },
        "w": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasPage": true
            }
          }
        }
      },
      "lowerCase": {
        "post": "post",
        "w": "w"
      }
    },
    "contact": {
      "hasPage": true
    },
    "contentForYou": {
      "hasPage": true
    },
    "crosspostLogin": {
      "hasPage": true
    },
    "debug": {
      "staticChildren": {
        "digestEmailPreview": {
          "hasPage": true
        },
        "emailHistory": {
          "hasPage": true
        },
        "linkPreview": {
          "hasPage": true
        },
        "markdownApi": {
          "hasPage": true
        },
        "notificationEmailPreview": {
          "hasPage": true
        },
        "query-waterfall": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "digestemailpreview": "digestEmailPreview",
        "emailhistory": "emailHistory",
        "linkpreview": "linkPreview",
        "markdownapi": "markdownApi",
        "notificationemailpreview": "notificationEmailPreview",
        "query-waterfall": "query-waterfall"
      }
    },
    "dialogues": {
      "hasPage": true
    },
    "donate": {
      "hasPage": true
    },
    "drafts": {
      "hasPage": true
    },
    "editPost": {
      "hasPage": true
    },
    "emailToken": {
      "dynamicChild": {
        "paramName": "token",
        "child": {
          "hasPage": true
        }
      }
    },
    "events": {
      "dynamicChild": {
        "paramName": "_id",
        "child": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasPage": true
            }
          },
          "hasPage": true
        }
      }
    },
    "faq": {
      "hasPage": true
    },
    "favicon.ico": {
      "hasRoute": true
    },
    "feed": {
      "hasPage": true
    },
    "feed.xml": {
      "hasRoute": true
    },
    "g": {
      "dynamicChild": {
        "paramName": "groupId",
        "child": {
          "staticChildren": {
            "p": {
              "dynamicChild": {
                "paramName": "_id",
                "child": {
                  "hasPage": true
                }
              }
            }
          },
          "lowerCase": {
            "p": "p"
          }
        }
      }
    },
    "glossaryEditor": {
      "hasPage": true
    },
    "graphiql": {
      "hasRoute": true
    },
    "graphql": {
      "hasRoute": true
    },
    "groups": {
      "dynamicChild": {
        "paramName": "groupId",
        "child": {
          "hasPage": true
        }
      }
    },
    "groups-map": {
      "hasPage": true
    },
    "highlights": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      },
      "hasPage": true
    },
    "hocuspocusWebhook": {
      "hasPage": true
    },
    "hpmor": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      },
      "hasPage": true
    },
    "inbox": {
      "hasPage": true
    },
    "item": {
      "hasRoute": true
    },
    "leaderboard": {
      "hasPage": true
    },
    "library": {
      "hasPage": true
    },
    "login": {
      "hasPage": true
    },
    "loginNotice": {
      "hasPage": true
    },
    "logout": {
      "hasRoute": true
    },
    "lw": {
      "dynamicChild": {
        "paramName": "id",
        "child": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "dynamicChild": {
                "paramName": "commentId",
                "child": {
                  "staticChildren": {
                    ".rss": {
                      "hasRoute": true
                    }
                  },
                  "lowerCase": {
                    ".rss": ".rss"
                  },
                  "hasRoute": true
                }
              },
              "hasRoute": true
            }
          },
          "hasRoute": true
        }
      }
    },
    "meetups": {
      "hasPage": true
    },
    "message": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      }
    },
    "moderation": {
      "staticChildren": {
        "altAccounts": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "altaccounts": "altAccounts"
      },
      "hasPage": true
    },
    "moderatorComments": {
      "hasPage": true
    },
    "moderatorInbox": {
      "hasPage": true
    },
    "newLongformReview": {
      "hasPage": true
    },
    "newPost": {
      "hasPage": true
    },
    "nominatePosts": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "nominations": {
      "staticChildren": {
        "2018": {
          "hasPage": true
        },
        "2019": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "2018": "2018",
        "2019": "2019"
      }
    },
    "notifications": {
      "hasPage": true
    },
    "oauth": {
      "staticChildren": {
        "authorize": {
          "hasRoute": true
        },
        "register": {
          "hasRoute": true
        },
        "revoke": {
          "hasRoute": true
        },
        "token": {
          "hasRoute": true
        }
      },
      "lowerCase": {
        "authorize": "authorize",
        "register": "register",
        "revoke": "revoke",
        "token": "token"
      }
    },
    "pastEvents": {
      "hasPage": true
    },
    "payments": {
      "staticChildren": {
        "account": {
          "hasPage": true
        },
        "admin": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "account": "account",
        "admin": "admin"
      }
    },
    "petrov": {
      "staticChildren": {
        "ceremony": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "ceremony": "ceremony"
      }
    },
    "petrovDayPoll": {
      "hasPage": true
    },
    "petroyDayPoll": {
      "hasPage": true
    },
    "postAnalytics": {
      "hasPage": true
    },
    "posts": {
      "staticChildren": {
        "slug": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasPage": true
            }
          }
        }
      },
      "lowerCase": {
        "slug": "slug"
      },
      "dynamicChild": {
        "paramName": "_id",
        "child": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "staticChildren": {
                "comment": {
                  "dynamicChild": {
                    "paramName": "commentId",
                    "child": {
                      "hasPage": true
                    }
                  },
                  "hasPage": true
                }
              },
              "lowerCase": {
                "comment": "comment"
              },
              "hasPage": true
            }
          },
          "hasPage": true
        }
      }
    },
    "postsWithApprovedJargon": {
      "hasPage": true
    },
    "questions": {
      "hasPage": true
    },
    "quickReview": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "quicktakes": {
      "hasPage": true
    },
    "rationality": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      },
      "hasPage": true
    },
    "recommendations": {
      "hasPage": true
    },
    "rejection-review": {
      "hasPage": true
    },
    "research": {
      "staticChildren": {
        "projects": {
          "dynamicChild": {
            "paramName": "projectId",
            "child": {
              "hasPage": true
            }
          }
        }
      },
      "lowerCase": {
        "projects": "projects"
      },
      "hasPage": true
    },
    "resendVerificationEmail": {
      "hasPage": true
    },
    "resetPassword": {
      "dynamicChild": {
        "paramName": "token",
        "child": {
          "hasPage": true
        }
      }
    },
    "reviewAdmin": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "reviewVoting": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "reviews": {
      "dynamicChild": {
        "paramName": "year",
        "child": {
          "hasPage": true
        }
      }
    },
    "revisions": {
      "staticChildren": {
        "post": {
          "dynamicChild": {
            "paramName": "_id",
            "child": {
              "dynamicChild": {
                "paramName": "slug",
                "child": {
                  "hasPage": true
                }
              }
            }
          }
        },
        "w": {
          "dynamicChild": {
            "paramName": "slug",
            "child": {
              "hasPage": true
            }
          }
        }
      },
      "lowerCase": {
        "post": "post",
        "w": "w"
      }
    },
    "robots.txt": {
      "hasRoute": true
    },
    "s": {
      "dynamicChild": {
        "paramName": "_id",
        "child": {
          "staticChildren": {
            "p": {
              "dynamicChild": {
                "paramName": "postId",
                "child": {
                  "hasPage": true
                }
              }
            }
          },
          "lowerCase": {
            "p": "p"
          },
          "hasPage": true
        }
      }
    },
    "search": {
      "hasPage": true
    },
    "sequences": {
      "dynamicChild": {
        "paramName": "_id",
        "child": {
          "hasPage": true
        }
      },
      "hasPage": true
    },
    "sequencesNew": {
      "hasPage": true
    },
    "spotlights": {
      "hasPage": true
    },
    "u": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "hasPage": true
        }
      }
    },
    "upcomingEvents": {
      "hasPage": true
    },
    "user": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "catchAll": {
            "paramName": "params",
            "child": {
              "hasRoute": true
            }
          },
          "hasPage": true
        }
      }
    },
    "users": {
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "staticChildren": {
            "edit": {
              "hasPage": true
            },
            "replies": {
              "hasPage": true
            }
          },
          "lowerCase": {
            "edit": "edit",
            "replies": "replies"
          },
          "hasPage": true
        }
      }
    },
    "w": {
      "staticChildren": {
        "create": {
          "hasPage": true
        },
        "dashboard": {
          "hasPage": true
        },
        "random": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "create": "create",
        "dashboard": "dashboard",
        "random": "random"
      },
      "dynamicChild": {
        "paramName": "slug",
        "child": {
          "staticChildren": {
            "discussion": {
              "hasPage": true
            },
            "edit": {
              "hasPage": true
            },
            "history": {
              "hasPage": true
            }
          },
          "lowerCase": {
            "discussion": "discussion",
            "edit": "edit",
            "history": "history"
          },
          "hasPage": true
        }
      }
    },
    "wActivity": {
      "hasPage": true
    },
    "wFeed": {
      "hasPage": true
    },
    "wikitags": {
      "staticChildren": {
        "all": {
          "hasPage": true
        }
      },
      "lowerCase": {
        "all": "all"
      }
    }
  },
  "lowerCase": {
    ".well-known": ".well-known",
    "skill.md": "SKILL.md",
    "abtestgroups": "abTestGroups",
    "about": "about",
    "account": "account",
    "admin": "admin",
    "allcomments": "allComments",
    "allcommentswithreacts": "allCommentsWithReacts",
    "allposts": "allPosts",
    "allgroups": "allgroups",
    "analyticsevent": "analyticsEvent",
    "api": "api",
    "arbital": "arbital",
    "auth": "auth",
    "autocompletesettings": "autocompleteSettings",
    "bannotice": "banNotice",
    "bestoflesswrong": "bestoflesswrong",
    "bestoflesswrongadmin": "bestoflesswrongadmin",
    "bookmarks": "bookmarks",
    "books": "books",
    "cache": "cache",
    "ckeditor-token": "ckeditor-token",
    "ckeditor-webhook": "ckeditor-webhook",
    "codex": "codex",
    "collections": "collections",
    "community": "community",
    "compare": "compare",
    "contact": "contact",
    "contentforyou": "contentForYou",
    "crosspostlogin": "crosspostLogin",
    "debug": "debug",
    "dialogues": "dialogues",
    "donate": "donate",
    "drafts": "drafts",
    "editpost": "editPost",
    "emailtoken": "emailToken",
    "events": "events",
    "faq": "faq",
    "favicon.ico": "favicon.ico",
    "feed": "feed",
    "feed.xml": "feed.xml",
    "g": "g",
    "glossaryeditor": "glossaryEditor",
    "graphiql": "graphiql",
    "graphql": "graphql",
    "groups": "groups",
    "groups-map": "groups-map",
    "highlights": "highlights",
    "hocuspocuswebhook": "hocuspocusWebhook",
    "hpmor": "hpmor",
    "inbox": "inbox",
    "item": "item",
    "leaderboard": "leaderboard",
    "library": "library",
    "login": "login",
    "loginnotice": "loginNotice",
    "logout": "logout",
    "lw": "lw",
    "meetups": "meetups",
    "message": "message",
    "moderation": "moderation",
    "moderatorcomments": "moderatorComments",
    "moderatorinbox": "moderatorInbox",
    "newlongformreview": "newLongformReview",
    "newpost": "newPost",
    "nominateposts": "nominatePosts",
    "nominations": "nominations",
    "notifications": "notifications",
    "oauth": "oauth",
    "pastevents": "pastEvents",
    "payments": "payments",
    "petrov": "petrov",
    "petrovdaypoll": "petrovDayPoll",
    "petroydaypoll": "petroyDayPoll",
    "postanalytics": "postAnalytics",
    "posts": "posts",
    "postswithapprovedjargon": "postsWithApprovedJargon",
    "questions": "questions",
    "quickreview": "quickReview",
    "quicktakes": "quicktakes",
    "rationality": "rationality",
    "recommendations": "recommendations",
    "rejection-review": "rejection-review",
    "research": "research",
    "resendverificationemail": "resendVerificationEmail",
    "resetpassword": "resetPassword",
    "reviewadmin": "reviewAdmin",
    "reviewvoting": "reviewVoting",
    "reviews": "reviews",
    "revisions": "revisions",
    "robots.txt": "robots.txt",
    "s": "s",
    "search": "search",
    "sequences": "sequences",
    "sequencesnew": "sequencesNew",
    "spotlights": "spotlights",
    "u": "u",
    "upcomingevents": "upcomingEvents",
    "user": "user",
    "users": "users",
    "w": "w",
    "wactivity": "wActivity",
    "wfeed": "wFeed",
    "wikitags": "wikitags"
  },
  "hasPage": true
} satisfies RouteNode;

export function canonicalizePath(pathname: string): string | null {
  // Normalize
  const qIndex = pathname.indexOf('?')
  const hIndex = pathname.indexOf('#')
  const cut = (v: number, acc: number) => (v === -1 ? acc : Math.min(v, acc))
  const end = cut(hIndex, cut(qIndex, pathname.length))
  const raw = pathname.slice(0, end)
  const segments = raw.split('/').filter(Boolean)

  let node: RouteNode | undefined = routeTrie
  const canonical: string[] = []

  function acceptLeaf(n: RouteNode | undefined): boolean {
    if (!n) return false
    return !!(n.hasPage || n.hasRoute)
  }

  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i]
    if (!node) return null

    // Prefer static match (case-insensitive)
    if (node.lowerCase && node.staticChildren) {
      const canon: string = node.lowerCase[seg.toLowerCase()]
      if (canon && node.staticChildren[canon]) {
        canonical.push(canon)
        node = node.staticChildren[canon]
        continue
      }
    }

    // Dynamic
    if (node.dynamicChild) {
      canonical.push(seg)
      node = node.dynamicChild.child
      continue
    }

    // Catch-all
    if (node.catchAll) {
      for (let j = i; j < segments.length; j++) canonical.push(segments[j])
      node = node.catchAll.child
      // Entire remainder consumed
      i = segments.length
      break
    }

    // Optional catch-all
    if (node.optionalCatchAll) {
      for (let j = i; j < segments.length; j++) canonical.push(segments[j])
      node = node.optionalCatchAll.child
      i = segments.length
      break
    }

    return null
  }

  // If we ended before consuming all segments due to catch-all, fine. Otherwise ensure leaf exists
  if (!segments.length) {
    return acceptLeaf(node) ? '/' : null
  }

  return acceptLeaf(node) ? '/' + canonical.join('/') : null
}
